// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TheWinOverview_wrapper_32wuX","rankInfoText":"TheWinOverview_rankInfoText_3ijpd","buttonTextWrapper":"TheWinOverview_buttonTextWrapper_3GcPF"};